import { isHybridApp } from '@neos/hybrid-app'
import { reportEvents, ReportGenerationSucceededEventArgs } from '@neos/core'
import { userPermissionsOnReportGenerationSucceededAsync } from '@src/sharedMethods/userPermissions'

/**
 * On user permissions init.
 */
export function appInitializationOnUserPermissionsInit(): void {
  if (isHybridApp()) {
    reportEvents.generationSucceeded.add((args) => userPermissionsOnReportGenerationSucceededAsync(args));
  }
}
